<template>
  <b-card no-body>
    <b-card-body>
      <b-container fluid="xl">
        <b-row align-v="center">
          <b-col cols="2">
            <div>
              <base-radio name="HARSH_ACCELERATION" class="mb-3" v-model="eventType">
                Harsh acceleration
              </base-radio>

              <base-radio name="HARSH_BRAKE" class="mb-3" v-model="eventType">
                Harsh brakes
              </base-radio>

              <base-radio name="OVER_SPEED_START" class="mb-3" v-model="eventType">
                Over speed start
              </base-radio>

              <base-radio name="OVER_SPEED_STOP" class="mb-3" v-model="eventType">
                Over speed stop
              </base-radio>

              <base-radio name="OVER_RPM_START" class="mb-3" v-model="eventType">
                Over RPM start
              </base-radio>

              <base-radio name="OVER_RPM_STOP" class="mb-3" v-model="eventType">
                Over RPM stop
              </base-radio>

              <base-radio name="IDLE_START" class="mb-3" v-model="eventType">
                Idle
              </base-radio>
            </div>
          </b-col>
          <b-col cols="10">
            <GmapMap
              ref="mapRef"
              :center="{lat: 52.18836, lng: 5.49317}"
              :zoom="7"
              map-type-id="roadmap"
              style="width: 1100px; height: 585px"
              :options="mapOptions">

              <HeatmapLayer ref="heatmapRef" :options="heatmapOptions" :data="points"/>
            </GmapMap>
          </b-col>
        </b-row>
      </b-container>
    </b-card-body>
  </b-card>
</template>

<script>
import crudApi from "../../crud/crud-api";
import {gmapApi} from 'vue2-google-maps'
import HeatmapLayer from "./HeatmapLayer";

export default {
  name: "entity-heatmap",
  props: {
    type: {
      type: String,
      default: 'ASSET',
      description: "Types : ASSET, DRIVER"
    },
    entityId: {
      type: String,
      required: true,
      description: "Entity ID"
    },
  },
  components: {
    HeatmapLayer
  },
  created() {
    this.eventType = this.$store.state.heatmap.eventType

    this.loadEvents()
  },
  data: _ => ({
    points: [],
    events: undefined,
    eventType: "HARSH_ACCELERATION",
    mapOptions: {
      zoomControl: true,
      mapTypeControl: true,
      scaleControl: false,
      streetViewControl: true,
      rotateControl: false,
      fullscreenControl: true,
      disableDefaultUi: false,
      styles: [
        {
          featureType: "poi",
          elementType: "all",
          stylers: [{ visibility: "off" }],
        }
      ],
    },
    heatmapOptions: {
      radius: 30,
      opacity:0.7,
      dissipating: true,
    }
  }),
  computed: {
    google: gmapApi,
  },
  methods: {
    refreshData() {
      this.loadEvents()
    },
    loadEvents() {
      let fromTime = undefined
      if (this.$store.state.filter.from) {
        fromTime = new Date(this.$store.state.filter.from)
      }

      let untilTime = undefined
      if (this.$store.state.filter.until) {
        untilTime = new Date(this.$store.state.filter.until)
      }

      let id = this.entityId

      if (this.type === 'ASSET') {
        crudApi.getAssetEvents(id, fromTime, untilTime).then(json => this.events = json.data ? json.data : json)
      } else {
        crudApi.getDriverEvents(id, fromTime, untilTime).then(json => this.events = json.data ? json.data : json)
      }

      console.log("Loading heatmap events for : " + id)
    },
    updatePoints() {
      let pts = []
      for (let d of this.events) {
        for (let e of d.events) {
          if (e.eventType === this.eventType) {
            pts.push({ location: new google.maps.LatLng(d.location.latitude / 100000, d.location.longitude / 100000), weight: 1 })
          }
        }
      }

      this.points = pts
    }
  },
  watch: {
    events: function() {
      this.updatePoints()
    },
    eventType: function () {
      this.$store.state.heatmap.eventType = this.eventType

      this.updatePoints()
    },
    '$store.state.filter.update': function () {
      this.refreshData()
    },
  }
}
</script>

<style scoped>

</style>
